import {
  initialState,
  Actions,
  State,
  EDIT_CUSTOM_CONTENT_TYPE,
  EDIT_CUSTOM_CONTENT_TYPE_SUCCESS,
  EDIT_CUSTOM_CONTENT_TYPE_ERROR,
  RESET_EDIT_CUSTOM_CONTENT_TYPE,
} from '../../types/custom-content-tye/edit'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_CUSTOM_CONTENT_TYPE:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case EDIT_CUSTOM_CONTENT_TYPE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case EDIT_CUSTOM_CONTENT_TYPE_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_EDIT_CUSTOM_CONTENT_TYPE:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
